export default "__VITE_ASSET__CcAQoR64__"